/* eslint-disable spire/export-styles */
// import { MainNavigationStyles, MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation";

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@insite/mobius/Menu";
import { navigationInteraction } from "@WhiteCap/Common/Utillities/CustomTracking";
// import Popover from "@insite/mobius/Popover";
import Popover from "@WhiteCap/Components/CustomPopover";
import HeaderMenuLinkManager from "@WhiteCap/Components/HeaderMenuLinkManager";
import CustomMenu from "@WhiteCap/Icons/CustomMenu";
import { MainNavigationStyles, MappedLink } from "@WhiteCap/Overrides/Widgets/Header/MainNavigation";
import * as React from "react";
import { ThemeProps, withTheme } from "styled-components";

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement>;
    isOpen: boolean;
    isAuth: boolean;
    displayChangeCustomerLink: boolean;
}

type Props = ThemeProps<BaseTheme> & OwnProps;

class MainNavigationItem extends React.Component<Props> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();
    state = {
        activeTab: "",
    };
    componentDidUpdate(prevProps: Readonly<Props>) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement | HTMLUListElement, MouseEvent>) => {
        this.setState({ activeTab: e.currentTarget.id.split("_")[1] });
    };

    handleMouseLeave = (e: React.MouseEvent<HTMLAnchorElement | HTMLUListElement, MouseEvent>) => {
        this.setState({ activeTab: "" });
    };

    sendDataLayer = (navigationClickText: string) => {
        navigationInteraction({
            event: 'navigation_interaction',
            navigation_category: navigationClickText,
            navigation_click: navigationClickText
        })
    }

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            isAuth,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const customMenuIcon = <StyledIcon src={CustomMenu} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading = hasChildren && link.childrenType === "CascadingMenu";
        const isMega = hasChildren && link.childrenType === "MegaMenu";
        const isActive = link.title === this.state.activeTab;
        // const generateUrl = () => {
        //     if (!isAuth && link.isLoggedInRequired) {
        //         toggleLogin({ loginDrawer: true });
        //     } else {
        //         window.location.href = link.url;
        //     }
        // };

        let menuLink = (
            <>
                <Link
                    className={`menu-item ${isActive ? "activeTab" : ""}`}
                    data-test-selector="megaMenuHover"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                    href={link.url}
                    onClick={() => { this.sendDataLayer(link.title) }}
                    // onClick={generateUrl}
                    target={link.openInNewWindow ? "_blank" : ""}
                    hoverStyle={{
                        textDecoration: isActive ? "underline #020508 4px" : "none",
                    }}
                >
                    {isCascading && customMenuIcon}
                    {link.title}
                </Link>
            </>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className={`menu-item ${isActive ? "activeTab" : ""}`}
                    data-test-selector="megaMenuHover"
                    href={link.url || "#"}
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                    hoverStyle={{
                        textDecoration: isActive ? "underline #020508 4px" : "none",
                    }}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                >
                    {(isCascading || isMega) && customMenuIcon}
                    {link.title}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        if (isMega) {
            menuItem = (
                <Popover
                    data-test-selector="megaMenuHover"
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        _width: 1280,
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement>) => {
                        if (this.props.container.current) {
                            const parentPosition = this.props.container.current.getBoundingClientRect();
                            const rect = element.current?.getBoundingClientRect();
                            const top = rect ? rect.top + (rect.height > 100 ? styles.menuHeight : rect.height) : 0;

                            const cartWidth = 150;
                            const breakpointMaxWidth = maxWidths.find((value: number, index: number) => {
                                return (
                                    parentPosition.width + cartWidth <= value &&
                                    parentPosition.width + cartWidth > maxWidths[index - 1]
                                );
                            });

                            const width = breakpointMaxWidth ? breakpointMaxWidth - 30 : parentPosition.width;

                            return {
                                // top,
                                position: "absolute",
                                left: "0rem",
                                width: `100%`,
                                maxWidth: "1440px",
                                maxHeight: "calc(100vh - 140px)",
                                overflow: "hidden auto",
                            };
                        }
                        return { position: "absolute" };
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    // onMouseOver={e => this.handleMouseEnter(e)}
                    // onMouseLeave={this.handleMouseLeave}
                    onMouseEnter={this.handleMouseEnter} // Handle popover hover
                    onMouseLeave={this.handleMouseLeave} // Handle popover leave
                >
                    <GridContainer
                        className="mega-menu-grid-container"
                        data-test-selector={`mainNavigationItem_${index}`}
                        {...styles.megaMenuGridContainer}
                        offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                    >
                        <HeaderMenuLinkManager link={link} styles={styles} onHandleClose={this.closePopover} />
                    </GridContainer>
                </Popover>
            );
        }

        return menuItem;
    }
}

export default withTheme(MainNavigationItem);
